/**
 * filter-entities — entidades que a aba Filtros de um nó de AÇÃO oferece.
 *
 * A aba Filtros dos 3 gatilhos (`TRIGGERS_WITH_FILTERS`) já resolve isso via
 * `filterEntitiesForTrigger` (event-entities.ts), lendo `config.filters`. Os
 * demais nós filtráveis (`nodeTypeAcceptsFilters`, @troia-v3/types) guardam o
 * filtro em `data.filters` e o universo de campos vem do CONTEXTO que o nó já
 * tem disponível (`AvailableContext`, calculado pelos predecessores) — nunca
 * de um evento de gatilho, que esses nós não têm.
 *
 * `system` (data e hora — `{{system.isBusinessHours}}` e companhia) entra
 * SEMPRE, por último: é injetado pelo motor em toda execução, independente do
 * contexto do nó (ao contrário da aba Filtros dos gatilhos, avaliada antes de
 * a execução começar — lá `system` não é oferecido, ver event-entities.ts).
 */
import type { AvailableContext } from './node-schemas';
import type { ContextCategory } from '../types/variables';

/** Ordem de exibição das entidades — mesma da FilterBuilder/VariableAutocomplete. */
const ORDEM: ReadonlyArray<Exclude<ContextCategory, 'system' | 'cancellation'>> = ['contact', 'conversation', 'lead', 'ticket', 'ai', 'event'];

/**
 * Entidades que a aba Filtros de um nó de ação oferece: as que o contexto do
 * nó conhece, mais o sistema (data e hora).
 *
 * `belowCancelledOutput` acrescenta o bloco do desvio (`{{cancelamento.*}}`,
 * spec 2026-09-20 §7.2/§7.7): ele só existe em runtime nos nós que estão
 * DEPOIS da saída "Cancelado" de um Aguardar — ver `cancelled-branch.ts`.
 */
export function entidadesParaFiltro(
  ctx: AvailableContext,
  belowCancelledOutput = false,
): ContextCategory[] {
  const presentes = ORDEM.filter((k) => ctx[k] === true);
  return [...presentes, 'system', ...(belowCancelledOutput ? (['cancellation'] as const) : [])];
}
